import React, { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import "./Stepper.scss";

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const Stepper = ({
  value = 0,
  min = 1,
  max = 999,
  onChange,
  disabled = false,
  className = "",
  size = "medium",
  editable = false,
}) => {
  const [draft, setDraft] = useState(String(value));

  useEffect(() => {
    setDraft(String(value));
  }, [value]);

  const handleDecrease = () => {
    if (!disabled && value > min && onChange) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (!disabled && value < max && onChange) {
      onChange(value + 1);
    }
  };

  const commitDraft = () => {
    const parsed = parseInt(draft, 10);
    if (Number.isNaN(parsed)) {
      setDraft(String(value));
      return;
    }
    const next = clamp(parsed, min, max);
    if (next !== value && onChange) {
      onChange(next);
    } else {
      setDraft(String(next));
    }
  };

  const handleInputChange = (e) => {
    const raw = e.target.value;
    if (raw === "" || /^\d+$/.test(raw)) {
      setDraft(raw);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.target.blur();
    }
  };

  const isDecreaseDisabled = disabled || value <= min;
  const isIncreaseDisabled = disabled || value >= max;

  return (
    <div className={`stepper stepper--${size} ${className}`}>
      <button
        className="stepper__btn stepper__btn--minus"
        onClick={handleDecrease}
        disabled={isDecreaseDisabled}
        type="button"
      >
        <RemoveIcon />
      </button>
      {editable ? (
        <input
          className="stepper__input"
          type="text"
          inputMode="numeric"
          value={draft}
          disabled={disabled}
          onChange={handleInputChange}
          onBlur={commitDraft}
          onKeyDown={handleKeyDown}
        />
      ) : (
        <span className="stepper__value">{value}</span>
      )}
      <button
        className="stepper__btn stepper__btn--plus"
        onClick={handleIncrease}
        disabled={isIncreaseDisabled}
        type="button"
      >
        <AddIcon />
      </button>
    </div>
  );
};

export default Stepper;
